import { ReactNode } from "react";

/** Standard section header for cards across the app. Same horizontal
 *  padding (``px-5 py-4``) and hairline-below treatment so a column of
 *  cards reads as one unified rhythm. ``right`` is an optional inline
 *  action slot for "View all →" links or small buttons. */
export function SectionHeader({
  title,
  subtitle,
  right,
}: {
  title: string;
  subtitle?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div className="px-5 py-4 border-b border-white/5 flex items-start justify-between gap-3">
      <div className="min-w-0">
        <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500 leading-tight">{title}</div>
        {subtitle && (
          <div className="text-[11.5px] text-slate-500 mt-1 leading-snug">
            {subtitle}
          </div>
        )}
      </div>
      {right && <div className="flex-shrink-0">{right}</div>}
    </div>
  );
}
